/** Shared outline button class for subscription actions (matches filled button height). */
export const OUTLINE_BRAND_BTN_CLASS =
  "tw:w-full tw:rounded-md tw:border-[#523D33] tw:box-border tw:text-[#523D33] tw:shadow-none hover:tw:bg-[#523D33]/5 tw:bg-clip-border tw:font-bold tw:uppercase tw:tracking-wide tw:text-[14px]";

/** Filled (pink) primary action button. */
export const PRIMARY_BRAND_BTN_CLASS =
  "tw:w-full tw:rounded-md tw:bg-[#FAC8CA] tw:border-[#FAC8CA] tw:text-[#523D33] hover:tw:bg-[#FAC8CA]/80 tw:font-bold tw:uppercase tw:tracking-wide tw:text-[14px]";

/** Filled (dark) action button. */
export const DARK_BRAND_BTN_CLASS =
  "tw:w-full tw:rounded-md tw:bg-[#523D33] tw:border-[#523D33] tw:text-[#FAC8CA] hover:tw:bg-[#523D33]/80 hover:tw:text-[#FAC8CA] tw:font-bold tw:uppercase tw:tracking-wide tw:text-[14px]";
